import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import { PROJECT_NAME } from '../../services/config';
import CastingsHelper from '../../store/castings/action';
import CompaniesHelper from '../../store/companies/action';
import UsersHelper from '../../store/users/action';

import { Icon } from '..';

import './styles.scss';

const menuItems = [
  {
    name: 'Dashboard',
    link: '/',
    icon: 'home',
    activeIcon: 'home-filled',
  },
  {
    name: 'Users',
    link: '/users',
    icon: 'people',
    activeIcon: 'people-filled',
  },
  {
    name: 'Companies',
    link: '/companies',
    icon: 'briefcase',
    activeIcon: 'briefcase-filled',
  },
  {
    name: 'Job offers',
    link: '/offers',
    icon: 'rich',
    activeIcon: 'rich-filled',
  },
];

const renderActiveLink = (link) => {
  if (link === window.location.pathname) {
    return true;
  }
  return false;
};

const renderToggleMenuItems = (massive, menuOpen, handleChangePage ) => massive.map((item) => (
  <Link
    to={item.link}
    className={renderActiveLink(item.link)
      ? 'toggle_menu__item__active toggle_menu__item'
      : 'toggle_menu__item'}
  >
    <button className={menuOpen
      ? 'toggle_menu__icon__open toggle_menu__icon'
      : 'toggle_menu__icon'}
      onClick={() => handleChangePage(item.link)}
    >
      {renderActiveLink(item.link) ? <Icon name={item.activeIcon} /> : <Icon name={item.icon} />}
    </button>
    <button className={menuOpen
      ? 'toggle_menu__name__show toggle_menu__name'
      : 'toggle_menu__name'}
      onClick={() => handleChangePage(item.link)}
    >
      <span>{item.name}</span>
    </button>
  </Link>
),
);

const ToggleMenu = (props) => {
  const dispatch = useDispatch();
  
  const handleChangePage = (link) => {
    if (link !== window.location.pathname) {
      const savedDataValues = Object.keys(sessionStorage);
      sessionStorage.clear();
      if (savedDataValues.includes('allCastings')) {
        dispatch(CastingsHelper.getAllCastings());
      }
      if (savedDataValues.includes('archivedCastings')) {
        dispatch(CastingsHelper.getArchivedCastings());
      }
      if (savedDataValues.includes('moderatedCastings')) {
        dispatch(CastingsHelper.getCastingsInModerated());
      }
      if (savedDataValues.includes('declinedCastings')) {
        dispatch(CastingsHelper.getDeclinedCastings());
      }
      if (savedDataValues.includes('allCompanies')) {
        dispatch(CompaniesHelper.getAllCompanies());
      }
      if (savedDataValues.includes('moderatedCompanies')) {
        dispatch(CompaniesHelper.getModeratedCompanies());
      }
      if (savedDataValues.includes('declinedCompanies')) {
        dispatch(CompaniesHelper.getDeclinedCompanies());
      }
      if (
        savedDataValues.includes('applicants') ||
        savedDataValues.includes('representatives') || 
        savedDataValues.includes('freelancers') || 
        savedDataValues.includes('recruiters')
      ) {
        dispatch(UsersHelper.getAllUsers());
      }
    }
  };

  return (
    <div className={props.menuOpen
      ? 'toggle_menu__container__open toggle_menu__container'
      : 'toggle_menu__container'}
    >
      <button
        onClick={() => {
          if (props.menuOpen) {
            props.menuOpenMarker(false);
          } else {
            props.menuOpenMarker(true);
          }
        }}
        className="toggle_menu__button"
      >
        <div className={props.menuOpen
          ? 'toggle_menu__icon__open toggle_menu__icon'
          : 'toggle_menu__icon'}
        >
          <Icon name="toggle-menu" />
        </div>
        <div className={props.menuOpen
          ? 'toggle_menu__name__show toggle_menu__name toggle_menu__company__name'
          : 'toggle_menu__name'}
        >
          <span>{PROJECT_NAME}</span>
        </div>
      </button>
      {renderToggleMenuItems(menuItems, props.menuOpen, handleChangePage)}
    </div>
  );
};

ToggleMenu.propTypes = {
  menuOpenMarker: PropTypes.func,
  menuOpen: PropTypes.bool,
};
ToggleMenu.defaultProps = {
  menuOpenMarker: () => {},
  menuOpen: false,
};

export default ToggleMenu;
